import { colors } from '../../../constants/color.constant';

export const statuses = {
    OFF: 'Off',
    ON: 'On',
    SAFE_MODE: 'SafeMode',
    STANDBY: 'Standby',

    WAIT: 'Wait',
    SUSPEND: 'Suspend',
    LIMIT: 'Limit',

    VOLTAGE_FAULT: 'VoltageFault',
    UNDER_VOLTAGE: 'UnderVoltage',
    OVER_VOLTAGE: 'OverVoltage',
    OVER_CONSUMPTION: 'OverConsumption',

    DEFAULT: 'default',
    OLD_DATA: 'old_data'
};

export const statusesInfo = {
    [statuses.OFF]: {
        className: 'is-off',
        classNameRn: 'isOff',
        text: 'Off',
        color: colors.OFF
    },
    [statuses.ON]: {
        className: 'is-on',
        classNameRn: 'isOn',
        text: 'On',
        color: colors.ON
    },
    [statuses.SAFE_MODE]: {
        className: 'is-safe-mode',
        classNameRn: 'isSafeMode',
        text: 'Safe mode',
        color: colors.SAFE
    },
    [statuses.STANDBY]: {
        className: 'is-standby',
        classNameRn: 'isStandby',
        text: 'Standby',
        color: colors.STANDBY
    },
    [statuses.WAIT]: {
        className: 'is-hold',
        classNameRn: 'isHold',
        text: 'On hold',
        color: colors.HOLD
    },
    [statuses.SUSPEND]: {
        className: 'is-hold',
        classNameRn: 'isHold',
        text: 'On hold',
        color: colors.HOLD
    },
    [statuses.LIMIT]: {
        className: 'is-hold',
        classNameRn: 'isHold',
        text: 'On hold',
        color: colors.HOLD
    },
    [statuses.VOLTAGE_FAULT]: {
        className: 'is-error',
        classNameRn: 'isError',
        text: 'Fault',
        color: colors.FAULT
    },
    [statuses.UNDER_VOLTAGE]: {
        className: 'is-error',
        classNameRn: 'isError',
        text: 'Fault',
        color: colors.FAULT
    },
    [statuses.OVER_VOLTAGE]: {
        className: 'is-error',
        classNameRn: 'isError',
        text: 'Fault',
        color: colors.FAULT
    },
    [statuses.OVER_CONSUMPTION]: {
        className: 'is-error',
        classNameRn: 'isError',
        text: 'Fault',
        color: colors.FAULT
    },
    [statuses.OLD_DATA]: {
        className: 'is-old-data',
        classNameRn: 'isOldData',
        text: '',
        color: colors.OLD
    },
    [statuses.DEFAULT]: {
        className: '',
        classNameRn: '',
        text: '',
        color: ''
    }
};


// WEBPACK FOOTER //
// ./~/pluton-core/lib/services/core/control/control.constant.js